import store from "@/store";
import axios from "axios";
import {toast} from "../class/Notification";
import router from "@/router";
import {findObjectIndex} from "../class/Converter";
import {formatNumber} from "../class/Converter";

const productDataShape = (form) => {
    let formData = new FormData();
    for (let i in form.items) {

        if (form.items[i].variation == 1) {

            formData.append(`features[${i}][feature_id]`, form.items[i].feature_id[0]);
            formData.append(`features[${i}][variation]`, 1);
            formData.append(`features[${i}][feature_attribute_id]`, form.items[i].feature_attributes[0]);

            if (form.items[i].link_feature_id != undefined && form.items[i].link_feature_id.length == 0) {
                formData.append(`features[${i}][quantity]`, form.items[i].quantity);
                formData.append(`features[${i}][price]`, form.items[i].price);
                formData.append(`features[${i}][offer]`, form.items[i].offer);
            } else {
                formData.append(`features[${i}][link_feature_id][id]`, form.items[i].feature_id[1]);
                formData.append(`features[${i}][link_feature_id][attribute_id]`, form.items[i].feature_attributes[1]);
                formData.append(`features[${i}][link_feature_id][quantity]`, form.items[i].quantity);
                formData.append(`features[${i}][link_feature_id][price]`, form.items[i].price);
                formData.append(`features[${i}][link_feature_id][offer]`, form.items[i].offer);
            }


        } else {
            formData.append(`features[${i}][feature_id]`, form.items[i].id);
            if (form.items[i].type == 'text') {
                formData.append(`features[${i}][feature_value]`, form.items[i].value);
            }
            if (form.items[i].type == 'list') {
                formData.append(`features[${i}][feature_attribute_id]`, form.items[i].value);
            }
            formData.append(`features[${i}][variation]`, 0);
        }


    }

    for (let i in form.selectedCategory) {
        formData.append(`category_id[${i}]`, form.selectedCategory[i]);
    }
    for (let i in form.keyWords) {
        formData.append(`keywords[${i}]`, form.keyWords[i]);
    }


    for (let [index, value] of Object.entries(form.images)) {
        formData.append(`images[${index}]`, value);
    }

    formData.append("thumbnail", form.mainImage);
    formData.append("name", form.name);
    formData.append("brand_id", form.selectedBrand);
    formData.append("link", form.link);

    formData.append("description", form.description);
    formData.append("is_digital", form.is_digital ? 1 : 0);
    formData.append("variation", form.variation ? 1 : 0);

    if (form.variation == false) {
        formData.append("price", form.price);
        formData.append("offer", form.discount);
        formData.append(
            "quantity",
            form.quantity != null ? form.quantity : ""
        );
        formData.append(
            "delivery_amount",
            form.shippingCost != null ? form.shippingCost : ""
        );
    }

    formData.append("status", form.published ? 1 : 0);
    return formData;
};

const queryBuilder = (filters) => {
    /* get items from  Filters component data state and create a query string for filters data
        supported filters:
        - brands
        - category
        - status
        - is_digital
        - price

         object shape should like this you can set arbitrary items in the object:
         filters: {
            price:{
                minValue: 0,
                maxValue: 1000000000,
            },
            category: [],
            brand: [],
            is_digital: 0
        },

    */
    let query = ''
    const keys = Object.keys(filters);
    for (let i in keys) {
        const key = keys[i]
        const value = filters[key];
        if (key == 'price' && (value.minValue != null && value.maxValue != null)) {
            query += `${key}=${value.minValue}-${value.maxValue}&`
        }
        if (key == 'search' || key == "is_digital" || key == "status" || key == 'sort') {
            query += `${key}=${value}&`
        }
        if (value.length > 0 && typeof value != 'string') { // check selected key have value
            const valueToString = value.join(',')
            query += `${key}=${valueToString}&`
        }
    }
    return query
}

export const getProductPrice = (product) => {

    if (product.variation == 0) {
        return formatNumber(product.price)
    } else {
        let price = [];
        product.features.forEach(feature => {

            let p1 = feature.feature_values.link_feature_value;
            let p2 = feature.feature_values;

            if (p1 != null) {
                if (!isNaN(parseInt(p1.price))) {
                    price.push(parseInt(p1.price))
                }
            }

            if (p2 != null) {
                if (!isNaN(parseInt(p2.price))) {
                    price.push(parseInt(p2.price))
                }
            }
        })

        // sort numbers
        price.sort((a, b) => a - b);
        // get the lowest number
        let min = price[0];
        // get the highest number
        let max = price[price.length - 1];

        return `${formatNumber(min)} - ${formatNumber(max)}`
    }
}

export const productPrice = (product) => {
    const item = product;
    const sub_product = item.sub_product
    product = product.product
    let price = {offer: 0, price: 0}
    if (product.variation == 0) {
        price.price = product.price
        price.offer = product.offer
    }
    if (product.variation == 1) {

        const product_features = product.features;

        for (let feature in product_features) {
            feature = product_features[feature]
            if (feature.feature_values.link_feature_value != null && feature.feature_values.link_feature_value.id == sub_product) {
                const base = feature.feature_values.link_feature_value;
                price.price = base.price
                price.offer = base.offer
            }
            if (feature.feature_values.link_feature_value == null && feature.feature_values.id == sub_product) {
                const base = feature.feature_values;
                price.price = base.price
                price.offer = base.offer
            }
        }

    }
    return price
}

export const productPriceOnUnAuthShoppingCard = (product) => {
    const sub_product = product.sub_product_id
    let price = {offer: 0, price: 0}
    if (product.variation == 0) {
        price.price = product.price
        price.offer = product.offer
    }
    if (product.variation == 1) {

        const product_features = product.features;

        for (let feature in product_features) {
            feature = product_features[feature]
            if (feature.feature_values.link_feature_value != null && feature.feature_values.link_feature_value.id == sub_product) {
                const base = feature.feature_values.link_feature_value;
                price.price = base.price
                price.offer = base.offer
            }
            if (feature.feature_values.link_feature_value == null && feature.feature_values.id == sub_product) {
                const base = feature.feature_values;
                price.price = base.price
                price.offer = base.offer
            }
        }

    }
    return price
}


export const productName = (product) => {
    const item = product;
    const sub_product = item.sub_product
    product = product.product
    let name = ''

    if (product.variation == 1) {

        const product_features = product.features;

        for (let feature in product_features) {
            feature = product_features[feature]
            if (feature.feature_values.link_feature_value != null && feature.feature_values.link_feature_value.id == sub_product) {
                const feature_attributes_id_1 = feature.feature_values.feature_attribute_id
                const feature_attributes_1 = feature.feature_attributes

                feature_attributes_1.forEach(item => {

                    if (item.id == feature_attributes_id_1) {
                        name += item.value
                    }
                })


                const feature_attributes_id_2 = feature.feature_values.link_feature_value.feature_attribute_id
                const feature_attributes_2 = feature.feature_values.link_feature.feature_attributes

                feature_attributes_2.forEach(item => {
                    if (item.id == feature_attributes_id_2) {
                        name += ' - ' + item.value
                    }
                })


            }

            if (feature.feature_values.link_feature_value == null && feature.feature_values.id == sub_product) {
                const feature_attributes_id_1 = feature.feature_values.feature_attribute_id
                const feature_attributes_1 = feature.feature_attributes

                feature_attributes_1.forEach(item => {

                    if (item.id == feature_attributes_id_1) {
                        name += item.value
                    }
                })
            }


        }

    }

    return name

}

export const subProducts = (product) => {

    if (product.variation == 0 || product.features.length == 0) {
        return [product]
    }

    const product_features = product.features;

    let product_variation_name = [];
    let product_variation = [];

    for (let feature in product_features) {
        feature = product_features[feature]

        if (feature.feature_values.sub_product == 1 || feature.feature_values.link_feature_value != null && feature.feature_values.link_feature_value.sub_product == 1) {

            const feature_attributes_id_1 = feature.feature_values.feature_attribute_id
            const feature_attributes_1 = feature.feature_attributes

            let sub_product = {name: '', sub_product_id: ''};

            feature_attributes_1.forEach(item => {

                if (item.id == feature_attributes_id_1) {
                    sub_product.name += item.value
                    sub_product.sub_product_id = feature.feature_values.id
                }
            })

            if (feature.feature_values.link_feature_value != undefined) {
                const feature_attributes_id_2 = feature.feature_values.link_feature_value.feature_attribute_id
                const feature_attributes_2 = feature.feature_values.link_feature.feature_attributes

                feature_attributes_2.forEach(item => {
                    if (item.id == feature_attributes_id_2) {
                        sub_product.name += ' - ' + item.value
                        sub_product.sub_product_id = feature.feature_values.link_feature_value.id
                    }
                })
            }


            product_variation_name.push(sub_product)
        }

    }

    product_variation_name.forEach(item => {
        let productClone = Object.assign({}, product)
        productClone.name = productClone.name + '  ' + item.name
        productClone.sub_product_id = item.sub_product_id
        product_variation.push(productClone)
    })


    return product_variation


}

export default {
    namespaced: true,
    state: {
        products: [],
        product: {},
        productBrand: {},
        filters: {
            price: {
                minValue: null,
                maxValue: null,
            },
            search: '',
            category: [],
            brand: [],
            is_digital: '',
            sort: ''
        },
        trash: [],
        meta: {},
        latestProducts: [],
        favoriteProducts: [],
        productComments: [],
        productUsers: [],
        offerProducts: []
    },
    mutations: {
        setFilters(state, filter) {
            const keys = Object.keys(state.filters)
            for (let i in keys) {
                state.filters[filter.key] = filter.value;
                return
            }
        },
        setProducts(state, products) {
            state.products = products;
        },
        setProduct(state, product) {
            state.product = product;
        },
        setProductBrand(state, brand) {
            state.productBrand = brand;
        },
        deleteProduct: (state, product) => {
            state.products.splice(
                findObjectIndex(store.getters["Product/getProducts"], product),
                1
            );
            state.trash.splice(
                findObjectIndex(store.getters["Product/getTrash"], product),
                1
            );
        },
        setTrash(state, products) {
            state.trash = products;
        },
        setMeta(state, meta) {
            state.meta = meta;
        },
        setLatestProducts(state, latestProducts) {
            state.latestProducts = latestProducts;
        },
        setFavoriteProduct(state, favoriteProducts) {
            state.favoriteProducts = favoriteProducts
        },
        setProductComments(state, comments) {
            state.productComments = comments
        },
        setProductUsers(state, users) {
            state.productUsers = users
        },
        setOfferProducts(state, products) {
            state.offerProducts = products
        }
    },
    actions: {
        setProducts({commit, state}, page = 1) {
            // convert filter items to query string
            const query = queryBuilder(state.filters)
            axios.get(`product?page=${page}&${query}`)
                .then((res) => {
                    let products = res.data.data;
                    commit("setProducts", products.data);
                    commit("setMeta", products.meta);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        setDashboardProducts({commit, state}, page = 1) {
            // convert filter items to query string
            const query = queryBuilder(state.filters)
            axios.get(`dashboard/product?page=${page}&${query}`)
                .then((res) => {
                    let products = res.data.data;
                    commit("setProducts", products.data);
                    commit("setMeta", products.meta);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        filteredProducts({commit, state}, filters) {
            const query = queryBuilder(state.filters)
            axios
                .get(`/general-search?${query}`)
                .then((res) => {
                    const products = res.data.data;
                    commit("setProducts", products.data);
                    commit("setMeta", []);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getProduct({commit}, link) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`product/${link}`)
                    .then((response) => {
                        response = response.data.data;
                        commit("setProduct", response);
                        commit("setProductBrand", response.brand);
                        resolve(response);
                    })
                    .catch((error) => {
                        router.push({name: "NotFound"});
                        reject(error);
                    });
            });
        },
        getDashboardProduct({commit}, link) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`dashboard/single/product/${link}`)
                    .then((response) => {
                        response = response.data.data;
                        commit("setProduct", response);
                        commit("setProductBrand", response.brand);
                        resolve(response);
                    })
                    .catch((error) => {
                        router.push({name: "NotFound"});
                        reject(error);
                    });
            });
        },
        createProduct({commit}, form) {
            let formData = productDataShape(form);

            // show formData items
            for (let pair of formData.entries()) {
                console.log(pair[0] + ', ' + pair[1]);
            }


            axios
                .post("/product", formData)
                .then((res) => {
                    const product = res.data.data;
                    router.push({
                        name: "EditProduct",
                        params: {slug: product.raw_link},
                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        async showProduct({commit}, form) {
            return await axios.get(`/product/${form.link}`);
        },
        updateProduct({commit}, form) {
            let formData = productDataShape(form);

            if (form.mainImage === undefined || form.mainImage.length === 0) {
                formData.delete("thumbnail");
            }


            formData.append("_method", "PUT");

            axios
                .post(`/product/${form.id}`, formData)
                .then((res) => {
                    const product = res.data.data;
                    if (router.currentRoute.params.slug != product.raw_link) {
                        router.push({
                            name: "EditProduct",
                            params: {slug: product.raw_link},
                        });
                    }
                    commit("setProduct", product);
                    toast("عملیات با موفقیت انجام شد", "محصول  با موفقیت ویرایش شد.");

                })
                .catch((error) => {
                    console.log(error);
                });
        },
        deleteImage({commit}, index) {
            const product = store.getters["Product/getProduct"];
            const image = product.images[index];
            const form = {
                _method: "DELETE",
                images: [image.id],
            };

            axios
                .post(`product/${product.id}/delete-image`, form)
                .then((res) => {
                    toast("عملیات با موفقیت انجام شد", "عکس  با موفقیت حذف شد.");
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        deleteProduct({commit}, product) {
            axios
                .delete(`/product/${product.id}`)
                .then((res) => {
                    const deletedProduct = res.data.data;
                    commit("deleteProduct", deletedProduct);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getTrash({commit}) {
            axios
                .post("/product/trash")
                .then((res) => {
                    const trashItems = res.data.data.data;
                    commit("setTrash", trashItems);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        restoreProduct({commit}, product) {
            axios
                .put(`/product/${product.id}/restore`)
                .then((res) => {
                    const restoredProduct = res.data.data;
                    commit("deleteProduct", restoredProduct);
                    const products = {
                        ...store.getters["Product/getProducts"],
                        restoredProduct,
                    }; // todo : fix issue of send array instead of object
                    commit("setProducts", products);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        forceDeleteProduct({commit}, product) {
            axios
                .delete(`/product/${product.id}/force-delete`)
                .then((res) => {
                    const deletedProduct = res.data.data;
                    commit("deleteProduct", deletedProduct);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getLatestProducts({commit}) {

            axios.get(`product?page=1&is_digital=0`)
                .then((res) => {
                    let products = res.data.data;
                    commit("setLatestProducts", products.data);
                    commit("setMeta", products.meta);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getFavoriteProducts({commit}) {
            axios.get(`favorite/products`)
                .then((res) => {
                    let products = res.data.data;
                    commit("setFavoriteProduct", products);
                    commit("setMeta", products.meta);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getProductComments({commit}, productId) {
            axios.get(`product/${productId}/comments`)
                .then((res) => {
                    let comments = res.data.data;
                    commit("setProductComments", comments.data);
                    commit("setMeta", comments);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getProductUsers({commit}, form) {
            axios.post(`product/products-user/${form.product_id}`, form)
                .then((res) => {
                    let users = res.data.data;
                    commit("setProductUsers", users);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        addUserToProduct({commit}, form) {
            axios.post(`product/add-user-to-product/${form.product_id}/user/${form.user_id}`, form)
                .then((res) => {
                    toast('عملیات با موفقیت انجام شد', 'کاربر با موفقیت به محصول اضافه شد')
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        removeUserProduct({commit}, form) {
            axios.post(`product/remove-user-product/${form.product_id}/user/${form.user_id}/order/${form.order_id}`, form)
                .then((res) => {
                    toast('عملیات با موفقیت انجام شد', 'کاربر با موفقیت از محصول حذف شد')
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getOfferProducts({commit}) {
            axios.get(`/products/with-offer`)
                .then((res) => {
                    let products = res.data.data;
                    commit("setOfferProducts", products.data);
                    commit("setMeta", products.meta);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        deleteProductFeature({commit}, form) {
            console.log(form)
            axios.delete(`/product/delete-product-feature/${form.update_info.id}`)
                .then((res) => {
                    toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        updateFeatureOfTheProduct({commit}, form) {
            const formData = new FormData()
            console.log(form)
            formData.append(`_method`, 'put');
            if (form.type == 'list') {
                formData.append(`features[0][feature_id]`, form.update_info.feature_id);


                if (form.variation == 0 && form.type == 'list') {
                    formData.append(`features[0][feature_attribute_id]`, form.value);
                } else {
                    formData.append(`features[0][feature_attribute_id]`, form.update_info.feature_attribute_id);
                }

                formData.append(`features[0][feature_value]`, form.update_info.feature_value);
                formData.append(`features[0][variation]`, form.update_info.variation);

                formData.append(`features[0][quantity]`, form.quantity);
                formData.append(`features[0][price]`, form.price);
                formData.append(`features[0][offer]`, form.offer);

                axios.post(`product/${form.update_info.product_id}/update-feature/feature-product/${form.update_info.id}`, formData)
                    .then((res) => {
                        toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')
                    })
                    .catch((error) => {
                        console.log(error);
                    });


            } else {
                formData.append(`features[0][feature_id]`, form.feature_id);
                formData.append(`features[0][feature_attribute_id]`, form.feature_attributes);
                formData.append(`features[0][feature_value]`, form.value);
                formData.append(`features[0][variation]`, form.variation);
                formData.append(`features[0][quantity]`, form.quantity);
                formData.append(`features[0][price]`, form.price);
                formData.append(`features[0][offer]`, form.offer);


                axios.post(`product/${form.product_id}/update-feature/feature-product/${form.id}`, formData)
                    .then((res) => {
                        toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')
                    })
                    .catch((error) => {
                        console.log(error);
                    });


            }


        },
        createFeatureProduct({commit}, form) {
            console.log(form)
            const formData = new FormData()

            if (form.feature_id != undefined && form.feature_id.length > 0) {

                formData.append(`features[0][feature_id]`, form.feature_id[0]);
                formData.append(`features[0][feature_attribute_id]`, form.feature_attributes[0]);
                formData.append(`features[0][variation]`, 1);

                formData.append(`features[0][quantity]`, form.quantity);
                formData.append(`features[0][price]`, form.price);
                formData.append(`features[0][offer]`, form.offer);

                if (form.feature_id.length > 1) {
                    formData.append(`features[0][link_feature_id][id]`, form.feature_id[1]);
                    formData.append(`features[0][link_feature_id][attribute_id]`, form.feature_attributes[1]);

                    formData.append(`features[0][link_feature_id][quantity]`, form.quantity);
                    formData.append(`features[0][link_feature_id][price]`, form.price);
                    formData.append(`features[0][link_feature_id][offer]`, form.offer);
                }


            } else {
                formData.append(`features[0][feature_id]`, form.id);
                if (form.type == 'list') {
                    formData.append(`features[0][feature_attribute_id]`, form.feature_attributes[0].value);
                }
                formData.append(`features[0][feature_value]`, form.value);
                // linked_feature_id

                formData.append(`features[0][variation]`, form.variation == undefined ? 0 : form.variation);
                if (form.quantity != undefined) formData.append(`features[0][quantity]`, form.quantity);
                if (form.price != undefined) formData.append(`features[0][price]`, form.price);
                if (form.offer != undefined) formData.append(`features[0][offer]`, form.offer);
            }

            return axios.post(`product/${form.product_id}/add-feature`, formData);
        },
        updateQuantityPriceOffer({commit}, form) {
            axios
                .post(`/product/update/quantity-price-offer`, form)
                .then((res) => {
                    toast("عملیات با موفقیت انجام شد", "محصول  با موفقیت ویرایش شد.");
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        setProductsWithoutState({commit, state}, page = 1) {
            // convert filter items to query string
            const query = queryBuilder(state.filters)
            return axios.get(`product?page=${page}&${query}`)
        },
        getProductWithoutState({commit}, link) {
            return axios.get(`product/${link}`)
        },
        searchProduct({commit}, {form}) {
            console.log(form)
            axios
                .get(`/general-search?search=${form.words}`)
                .then((res) => {
                    const products = res.data.data;
                    commit("setProducts", products.data);
                    commit("setMeta", []);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    },
    getters: {
        getProducts: (state) => state.products,
        getProduct: (state) => state.product,
        getFilter: (state) => (key) => {
            const keys = Object.keys(state.filters)
            for (let i in keys) {
                return state.filters[key];
            }
        },
        getProductBrand: (state) => state.productBrand,
        getTrash: (state) => state.trash,
        getPaginationMeta: (state) => state.meta,
        getLatestProduct: (state) => state.latestProducts,
        getFavoriteProducts: (state) => state.favoriteProducts,
        getProductComments: (state) => state.productComments,
        getProductUsers: (state) => state.productUsers,
        getOfferProducts: (state) => state.offerProducts,
        getFilters: (state) => state.filters
    },
};
